/**
 * Vanilla URLSearchParams helpers intended for usage inside Three/Fiber components
 * where react-router-dom hooks are not accessible.
 */

export const readSearchParam = (key: string): string | null => {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  } catch {
    return null;
  }
};

export const deleteSearchParam = (key: string): void => {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(key)) return;
    url.searchParams.delete(key);
    window.history.replaceState({}, '', url.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch {
    // ignore URL/history errors
  }
};

export const setViewportSearchParamAndRemoveMapbox = (viewport: unknown): void => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('mapbox');
    url.searchParams.delete('fromDate');
    url.searchParams.delete('toDate');
    url.searchParams.delete('dateRangeType');
    url.searchParams.set(
      'viewport',
      typeof viewport === 'string' ? viewport : JSON.stringify(viewport),
    );
    window.history.replaceState({}, '', url.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch {
    // ignore URL/history errors
  }
};
